import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { downscale } from 'src/conf/scale';

export class BuddiesMultipliers extends View {
  private base: ImageScaleView;
  private text1: LangBitmapFontTextView;
  private text2: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      width: downscale(794),
      height: downscale(178),
    });

    this.base = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupBaking/multiplier_bar.png',
      scaleMethod: 'contain',
      width: this.style.width,
      height: this.style.height,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    this.text1 = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      font: 'Body',
      color: '#754A22',
      width: 200,
      height: 40,
      x: 10,
      y: 8,
      letterSpacing: -2,
      localeText: () => i18n('match2.buddies.bakingPopup.rewardText1'),
    });

    this.text2 = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      font: 'Body',
      color: '#754A22',
      width: 200,
      height: 40,
      x: 210,
      y: 8,
      letterSpacing: -2,
      localeText: () => i18n('match2.buddies.bakingPopup.rewardText2'),
    });
  }
}
